import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {ReseauClientListPage} from './ReseauClientListPage'
import {ReseauClientAddPage} from './ReseauClientAddPage'
import {ReseauClientEditPage} from './ReseauClientEditPage'

const ReseauClientWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Réseau client</PageTitle>
              <ReseauClientListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Réseau client', path: '/reseau-client', isSeparator: false, isActive: true },
              ]}>Création</PageTitle>
              <ReseauClientAddPage />
            </>
          }
        />
        <Route
          path=':reseauClientId/modifier'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Réseau client', path: '/reseau-client', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <ReseauClientEditPage />
            </>
          }
        />
        <Route index element={<Navigate to='/reseau-client/liste' />} />
      </Routes>
    </>
  )
}

export {ReseauClientWrapper}
